import { render, staticRenderFns } from "./ResetAccess.vue?vue&type=template&id=4e50e5ff&scoped=true&"
import script from "./ResetAccess.vue?vue&type=script&lang=js&"
export * from "./ResetAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e50e5ff",
  null
  
)

export default component.exports